import React, { Component } from "react";
import PropTypes from "prop-types";
import Tab from "./tab";

class Tabs extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Array).isRequired,
    tabActiveStyles: PropTypes.string.isRequired,
    tabInactiveStyles: PropTypes.string.isRequired,
    tabStyles: PropTypes.string.isRequired,
    tabs: PropTypes.string,
    styles: PropTypes.string,
    contentStyles: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      activeTab: this.props.children[0].props.label,
    };
  }

  onClickTabItem = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const {
      onClickTabItem,
      props: { children, tabActiveStyles, tabInactiveStyles, tabStyles, tabs, styles, contentStyles },
      state: { activeTab },
    } = this;

    return (
      <div className={`tabs ${styles}`}>
        <div className={`flex justify-between ${tabs}`}>
          {children.map((child) => {
            const { label } = child.props;
            
            return (
              <Tab
                activeTab={activeTab}
                key={label}
                label={label}
                activeStyles={tabActiveStyles }
                inactiveStyles={tabInactiveStyles}
                tabStyles={tabStyles}
                onClick={onClickTabItem}
              />
            );
          })}
        </div>
        <div className={`${contentStyles}`}>
          {children.map((child) => {
            if (child.props.label !== activeTab) return undefined;
            return child.props.children;
          })}
        </div>
      </div>
    );
  }
}

export default Tabs;